var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-container pt-2",attrs:{"id":("previewChartContainer-" + _vm.scenarioElementId),"flat":"","tile":""}})}
var staticRenderFns = []

export { render, staticRenderFns }